import { Platform } from '@angular/cdk/platform';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import Swal from 'sweetalert2';
import { environment } from '@environments/environment';

import { AuthenticationService } from '@app/shared/services';
import { RedirectService } from '@app/core/services/redirect.service';
import { CensoService } from '@app/shared/services/censo.service';
import { SeguradoService } from '@app/shared/services/segurado.service';
import { MensagemService } from '@app/shared/services/mensagem.service';

import { Loading, Censo } from '@app/shared/models';

import { ModalDocumentosComponent } from './modal-documentos/modal-documentos.component';
import { ModalIdentidadeComponent } from './modal-identidade/modal-identidade.component';

@Component({
  selector: 'app-primeiro-passo',
  templateUrl: './primeiro-passo.component.html',
  styleUrls: ['./primeiro-passo.component.scss'],
})
export class PrimeiroPassoComponent {

  carregar = new Loading();
  censo: Censo;
  emContestacao: any = null;
  escondeBtn: any = { servidor: false, documento: false };

  cliente = environment.cliente;
  seguradoInformacoes: any = this.auth.currentUserValue;

  selfIcon = './../../../../../assets/images/self-icon.png';
  docsIcon = './../../../../../assets/images/docs-icon.png';

  buttons: any = null;

  constructor(
    public dialog: MatDialog,
    readonly platform: Platform,
    private auth: AuthenticationService,
    private censoService: CensoService,
    private cookieService: CookieService,
    private redirectService: RedirectService,
    private seguradoService: SeguradoService,
    private router: Router,
    private mensagemService: MensagemService
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
    this.moverParaURLCorreta();
    this.buttons = this.verificaEnvios();

    this.seguradoService.getSegurado(this.carregar).subscribe(segurado => {
      this.auth.currentUserValue.nome = segurado.nome;
      this.auth.currentUserValue.nomeMae = segurado.nomeMae;
    });

    if (!this.censo?.flagVideoIdentificacao) this.cookieService.set('videoSelfie', 'enviado');
  }

  proximaEtapa(): void {
    Swal.fire({
      title: 'Atenção',
      html:
        `Verifique se você enviou o documento, foto e vídeo solicitado.
        <br/> <br/> Ao finalizar essa etapa, o reenvio será liberado somente após análise do Instituto.`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Ok, vou verificar',
      confirmButtonText: 'Desejo seguir',
    }).then((response) => {
      if (response.value) {
        this.carregar.load = true;
        this.cookieService.deleteAll();
        if (this.emContestacao) {
          this.router.navigate(['/contestacao']);
        } else {
          this.router.navigate(['/recadastramento/segundo-passo']);
        }
      }
    });
  }

  abrirModalDocumentos(): any {
    const dialogRef = this.dialog.open(ModalDocumentosComponent, {
      panelClass: 'custom-documentos-modal',
      closeOnNavigation: false,
      disableClose: true,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.buttons = this.verificaEnvios();
        this.docsIcon = './../../../../../assets/images/docs-icon-active.png';
      }
    });
  }

  abrirModalIdentidade(): any {
    const dialogRef = this.dialog.open(ModalIdentidadeComponent, {
      panelClass: this.censo.flagVideoIdentificacao ? 'custom-documentos-modal' : 'custom-documentos-modal-sem-video',
      closeOnNavigation: false,
      disableClose: true,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.buttons = this.verificaEnvios();
        this.selfIcon = './../../../../../assets/images/self-icon-active.png';
      }
    });
  }

  verificaEnvios(): any {
    let servidor = false;
    let documento = false;

    if (
      (
        (this.cookieService.get('frenteFile') !== '' && this.cookieService.get('frenteFile') !== null) &&
        (this.cookieService.get('versoFile') !== '' && this.cookieService.get('versoFile') !== null)
      ) || this.escondeBtn.documento
    ) {
      documento = true;
    }

    if (
      (
        (this.cookieService.get('videoSelfie') !== '' && this.cookieService.get('videoSelfie') !== null) &&
        (this.cookieService.get('selfie') !== '' && this.cookieService.get('selfie') !== null)
      ) || this.escondeBtn.servidor
    ) {
      servidor = true;
      this.selfIcon = './../../../../../assets/images/self-icon-active.png';
    }
    return { documento, servidor };
  }

  logout(): void {
    this.mensagemService.avisoMensagemCondicional('', 'Você deseja realmente sair?', 'warning').then((response) => {
      if (response.value) {
        this.auth.logout();
        this.router.navigate(['/']);
      }
    });
  }

  moverParaURLCorreta(): void {
    this.redirectService.verificarEtapa(this.carregar).subscribe(([status, etapa]) => {
      if (status.documentosRejeitados?.length > 0 || status.identificacoesRejeitadas?.length > 0) {
        if (status.identificacoesRejeitadas?.length > 0) {
          this.cookieService.set('emContestacao', '1');
          this.emContestacao = true;
          this.redirectService.redirecionar(true, null, true);

          const identidadeRejeitado = status.identificacoesRejeitadas.filter(
            (aux: { tipoIdentificacao: string; status: string; }) =>
              (aux.tipoIdentificacao === 'VIDEO' && aux.status === 'RECUSADO') ||
              (aux.tipoIdentificacao === 'SELFIE' && aux.status === 'RECUSADO')
          );
          if (identidadeRejeitado.length <= 0) {
            this.escondeBtn.servidor = true;
            this.buttons.servidor = true;
            this.selfIcon = './../../../../../assets/images/self-icon-active.png';
          }

          const docRejeitado = status.identificacoesRejeitadas.filter(
            (aux: { tipoIdentificacao: string; status: string; }) =>
              (aux.tipoIdentificacao === 'DOC_VERSO' && aux.status === 'RECUSADO') ||
              (aux.tipoIdentificacao === 'DOC_FRENTE' && aux.status === 'RECUSADO')
          );
          if (docRejeitado.length <= 0) {
            this.escondeBtn.documento = true;
            this.buttons.documento = true;
          }

        } else {
          this.cookieService.delete('emContestacao');
          this.emContestacao = false;
          this.redirectService.redirecionar(true, null, false);
        }
      } else {
        this.redirectService.redirecionar(false, etapa);
      }
    });
  }
}
